'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const ActionTooltip = ({
  message
}) => /*#__PURE__*/_jsx("div", {
  className: "action-tooltip-content",
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: message
  })
});
export default ActionTooltip;